<template>
  <div>
    <!--    기본정보-->
    <field-select-module v-model="form.stdInfo" :options="[
        { type: 'date', label: '점검일'},
        { type: 'text', label: '점검장소'},
        { type: 'disaster', label: '재해형태'}
      ]" :board="this.board" :is-print="isPrint"/>

    <!--    장비정보-->
    <table-equipment
      class="mt-5"
      :list="form.equipmentList"
      @updateList="updateList"
      :isPrint="isPrint"
      :isReadonly="board.readonly"
    ></table-equipment>


    <!--    점검대상-->
<!--    <vs-row class="mt-6">-->
<!--      <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">-->
<!--        <h5>-->
<!--          <i class="dot"></i> 점검대상-->
<!--        </h5>-->
<!--      </vs-col>-->
<!--    </vs-row>-->

<!--    <div class="gap-x-6 gap-y-4 mt-4">-->
<!--      <span v-if="isPrint"> {{form.inspectionTitle}} </span>-->
<!--      <div class="ml-group-checkBox flex flex-wrap w-full flex-1" v-else>-->
<!--        <vs-checkbox-->
<!--          class="mr-1 mb-2"-->
<!--          :readonly="board.readonly">-->
<!--          {{form.inspectionTitle}}-->
<!--        </vs-checkbox>-->
<!--      </div>-->
<!--    </div>-->


    <!--    청소(미화)-->
    <table-inspect
      class="mt-5"
      :is-print="isPrint"
      :is-readonly="board.readonly"
      :is-show-title="true"
      :title="form.inspectionTitle"
      :list="form.inspectList"
      :is-note="true"
      :table-header-title="'자가진단 항목'"
      :table-header-yes="'양호'"
      :table-header-no="'미흡'"
      :table-header-na="'해당없음'"
      :table-header-note="'비고(보완계획)'"
      @update-list-check="updateListCheck"
      @update-note="updateListNote"
    />


    <!--    사진대지-->
    <PhotoUploadGridModule
      :row-count="2"
      :grid-count="2"
      v-model="form.photoList"
      :is-print="isPrint"
      :readonly="board.readonly"
      section-title="사진대지"
      placeholder="신축현장 점검"
    />

    <!--    파일첨부-->
    <file-upload-module
      id="fileList"
      class="w-full mt-4"
      v-model="form.fileList"
      :is-print="isPrint"
      :readonly="board.readonly"
    ></file-upload-module>

  </div>
</template>

<script>
import PopupPlanProject from '@/views/project/popup/PopupPlanProject'
import DateSelector from '@/components/selector/DateSelector'
import PopupProjectSetting from '@/views/project/PopupProjectSetting'
import MemberSelector from '@/components/selector/MemberSelector'
import CompanySelector from '@/components/selector/CompanySelector'
import FileUploader from '@/components/FileUploader'
import FileUploadModule from '@/views/modules/FileUploadModule'
import TableInspect from '@/components/TableInspect'
import TableEquipment from '@/components/TableEquipment'
import DisasterClassSelector from '@/components/selector/DisasterClassSelector'
import FieldSelectModule from '@/views/modules/FieldSelectModule'
import PhotoUploadGridModule from '@/views/modules/PhotoUploadGridModule'

export default {
  components: {
    FileUploadModule,
    TableInspect,
    TableEquipment,
    DisasterClassSelector,
    FileUploader,
    CompanySelector,
    MemberSelector,
    PopupProjectSetting,
    DateSelector,
    PopupPlanProject,
    FieldSelectModule,
    PhotoUploadGridModule
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler (value) {
        const keys = Object.keys(this.form)
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key]
          }
        }

        this.form.inspectionTitle = this.inspectionTitle
        if (!this.form || !this.form.inspectList || this.form.inspectList.length === 0) {
          this.form.inspectList = this.inspectTable
        }
      }
    },
    form: {
      immediate: true,
      deep: true,
      handler (value) {
        value.title = value.inputA_2
        this.$emit('input', value)
      }
    }
  },
  data () {
    return {
      inspectionTitle: '청소(미화)',
      form: {
        inspectionTitle: '청소(미화)',
        stdInfo: { },
        photoList: [],
        fileList: [],
        equipmentList: [],
        inspectList: []
      },
    }
  },
  computed: {
    inspectTable () {
      return  [
        {
          id: 1,
          label: '청소 후 바닥의 세제·물 등으로 미끄러질 위험 여부',
          is_checked: '',
          note: '',
        },
        {
          id: 2,
          label: '물품, 청소공구 등 지정된 장소에 보관 여부',
          is_checked: '',
          note: '',
        },
        {
          id: 3,
          label: '높은 곳 청소 시 계단식 작업발판 등 사용 여부',
          is_checked: '',
          note: '',
        },
        {
          id: 4,
          label: '사다리를 사용하는 작업에서 2인 1조 작업 준수 여부',
          is_checked: '',
          note: '',
        },
        {
          id: 5,
          label: '운반 물을 쌓아 올리고 내릴 때 무너짐 여부',
          is_checked: '',
          note: '',
        },
        {
          id: 6,
          label: '날카로운 물체 등에 의해 베임·찔림 등 위험 여부',
          is_checked: '',
          note: '',
        },
        {
          id: 7,
          label: '청소기 등 전선의 노후화 또는 피복 손상 여부',
          is_checked: '',
          note: '',
        },
        {
          id: 8,
          label: '벽면 물 세척 시 전기 누전으로 감전 위험 여부',
          is_checked: '',
          note: '',
        },
        {
          id: 9,
          label: '젖은 손으로 전기기구를 취급하여 감전 위험 여부',
          is_checked: '',
          note: '',
        },
        {
          id: 10,
          label: '화학제품을 이용한 청소 시 환기 여부',
          is_checked: '',
          note: '',
        },
        {
          id: 11,
          label: '살균·소독·청소 시 고무장갑, 장화 등 개인보호구 착용 여부',
          is_checked: '',
          note: '',
        },
        {
          id: 12,
          label: '사용 세정제의 물질안전보건자료(MSDS)의 게시(비치) 여부',
          is_checked: '',
          note: '',
        },
        {
          id: 13,
          label: '취급용기 및 포장에  MSDS 경고표지 부착 여부',
          is_checked: '',
          note: '',
        },
        {
          id: 14,
          label: '세정제 등 화학제품의 유해성 등 파악 여부',
          is_checked: '',
          note: '',
        },
        {
          id: 15,
          label: '근골격계 부담작업 종사자의 작업자세의 위험 여부',
          is_checked: '',
          note: '',
        },
        {
          id: 16,
          label: '근골격계부담 종사자에 대한 유해성 주지(교육 등) 적정성',
          is_checked: '',
          note: '',
        },
        {
          id: 17,
          label: '중량물 안내포스터 부착 유무 - 5kg 이상 물체를 중량물로 취급',
          is_checked: '',
          note: '',
        },
        {
          id: 18,
          label: '운반기계 또는 운반 도구를 사용하여 운반 여부',
          is_checked: '',
          note: '',
        },
      ]

    },
  },
  methods : {
    updateList (list) {
      this.form.equipmentList = list
    },
    updateListCheck (indexRows, text) {
      this.form.inspectList[indexRows].is_checked = text
    },
    updateListNote (indexRows, text) {
      this.form.inspectList[indexRows].note = text
    }
  }
}
</script>

<style scoped lang="scss">
$border: 1px solid #cdcdcd;
.label-text {
  width: 114px;
  font-weight: 500;
  font-size: 14px;
}
.mt-component-form {
  margin-top: 15px;
}

/* uploaded File */
.h-upload {
  height: 470px;
}
.upload-content {
  border: $border;
  &:last-child {
    border-left: none;
  }
  &__title {
    height: 54px;
    line-height: 54px;
    text-align: center;
    background: #fafafa;
    border-bottom: $border;
  }
  &__input {
    height: 54px;
    background: #f9f9f9;
    border-top: $border;
    padding: 5px 15px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  &__file {
    height: calc(100% - 54px);
    width: 100%;
    padding: 14px;
  }
}
</style>
